var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8508,
    cy: 19.0459,
    r: 10.5693,
    transform: "rotate(45 34.8508 19.0459)",
    fill: "#FEB005"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5556 12.6063C48.8541 9.9048 44.4742 9.90481 41.7728 12.6063L27.6188 26.7602C27.6189 26.7604 27.6191 26.7605 27.6192 26.7606C31.7468 30.8882 31.7468 37.5803 27.6192 41.7079C23.5128 45.8143 16.8681 45.8354 12.7356 41.7711C10.7896 44.4744 11.0325 48.266 13.4642 50.6977L41.7727 79.0063C44.4742 81.7077 48.8541 81.7077 51.5556 79.0063L79.8642 50.6977C82.5656 47.9962 82.5656 43.6163 79.8642 40.9149L51.5556 12.6063Z",
    fill: "#FEB005"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfLogo);
export default __webpack_public_path__ + "static/media/half-logo.c9343e3d.svg";
export { ForwardRef as ReactComponent };